import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class AgentPaymentListItem extends SearchModelBase {
    postDate: string | null = null;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;
    agent: string = '';
    billTo: number = 0;
    receivedFrom: string = '';
    checkNo: string = '';
    invoiceNo: string = '';
    bank: string = '';
    currency: string = '';
    amount: number|null = null;
    fromAmount: number|null = null;
    toAmount: number|null = null;
    depositDate: string | null = null;
    fromDepositDate: string | null = null;
    toDepositDate: string | null = null;
    isDraft: boolean|null = null;
    chkPrint: string = '';
    remark: string = '';
    u1ID: string = '';
    id: number = 0;
    u1Date: string | null = null;
    u2ID: string = '';
    u2Date: string | null = null;
    status: string = '';
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    agentId: number = 0;
    firstAgent: string = '';
    badDebtExp: boolean = false;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Draft', width: 40, dataIndex: 'isDraft', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 2, text: 'Block', width: 40, dataIndex: 'block', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 3, text: 'Date', width: 75, dataIndex: 'postDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Agent', width: 150, dataIndex: 'agent', defaultColumnFocus : true}),
        XCol.Create({ col: 5, text: 'Received From', width: 150, dataIndex: 'receivedFrom'}),
        XCol.Create({ col: 6, text: 'W/T #', width: 100, dataIndex: 'checkNo'}),
        XCol.Create({ col: 7, text: 'Bank', width: 120, dataIndex: 'bank'}),
        XCol.Create({ col: 8, text: 'CUR', width: 40, dataIndex: 'currency'}),
        XCol.Create({ col: 9, text: 'Amount', width: 100, dataIndex: 'amount', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 10, text: 'Clear Date', width: 75, dataIndex: 'depositDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 11, text: 'Batch #', width: 60, dataIndex: 'chkPrint'}),
        XCol.Create({ col: 12, text: 'Billings #', width: 100, dataIndex: 'invoiceNo'}),
        XCol.Create({ col: 13, text: 'Remark', width: 150, dataIndex: 'remark'}),
        XCol.Create({ col: 14, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 15, text: 'Create by', width: 100, dataIndex: 'u1ID'}),
        XCol.Create({ col: 16, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 17, text: 'Update by', width: 100, dataIndex: 'u2ID'}),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: AgentPaymentListItem.prototype.postDate, orderByAscending: false };

    public static formatData(data: AgentPaymentListItem[]) {
        return data.map((d: AgentPaymentListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields:{[key: string]: {[key: string]: string}} = {
        postDate: {from: 'fromPostDate', to: 'toPostDate'},
        depositDate: {from: 'fromDepositDate', to: 'toDepositDate'},
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        amount: {from: 'fromAmount', to: 'toAmount'},
    }
}
